import React, { useEffect, useState } from "react";
import GOFloatingbox from "../../common/GOFloatingbox";
import GOButton from "../../common/GOButton";
import { useTranslation } from "react-i18next";
import SmallTitle from "../../common/SmallTitle";
import {
  NetLessonDetail,
  NetLessonEdit,
  NetLessonDelete,
  NetReservationDetail,
  NetReservationEdit,
  NetReservationDelete
} from "../../../actions";
import GOLabel from "../../common/GOLabel";
import dayjs from "dayjs";
import "dayjs/locale/th";
import GOInput from "../../common/GOInput";
import GOLoading from "../../common/GOLoading";
import {
  UFloatingContainer,
  UFloatingBoxHeader,
  UFloatingBoxFooter,
  UFloatingBoxBody
} from "../../../GlobalUtilityStyles";

interface DetailProps {
  id: string;
  onClickExit?: any;
  update?: any;
  employee?: boolean;
}

const Detail = (props: DetailProps) => {
  const { t } = useTranslation();
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(true);
  dayjs.locale("th");

  useEffect(() => {
    if (props.employee) {
      // 개인레슨
      NetLessonDetail(props.id).then((res: any) => {
        setData(res.data.Data.LessonAvailability);
        setLoading(false);
      });
    } else {
      NetReservationDetail(props.id).then((res: any) => {
        setData(res.data.Data.PlateAvailability);
        setLoading(false);
      });
    }
  }, [props.employee, props.id]);

  const handleSubmit = () => {
    if (props.employee) {
      NetLessonEdit(props.id, data).then((res: any) => {
        alert(t("reservation.editComplete"));
      });
    } else {
      NetReservationEdit(props.id, data).then((res: any) => {
        alert(t("reservation.editComplete"));
      });
    }
  };

  const onDelete = () => {
    if (props.employee) {
      if (window.confirm(t("reservation.isDel"))) {
        NetLessonDelete(props.id).then((res: any) => {
          props.update();
          props.onClickExit();
        });
      }
    } else {
      if (window.confirm(t("reservation.isDel"))) {
        NetReservationDelete(props.id).then((res: any) => {
          props.update();
          props.onClickExit();
        });
      }
    }
  };

  if (loading) {
    return (
      <>
        <GOFloatingbox>
          <GOLoading />
        </GOFloatingbox>
      </>
    );
  } else if (props.employee) {
    return (
      <>
        <GOFloatingbox width={750}>
          <UFloatingContainer as="form">
            <UFloatingBoxHeader>
              <h1>{t("reservation.edit")}</h1>
              <p>{t("reservation.editInfo")}</p>
            </UFloatingBoxHeader>
            <UFloatingBoxBody flex>
              <div className="flex_box">
                <SmallTitle body={t("reservation.personal")} />
                <GOLabel label={t("reservation.lessonName")} body={data.name} />
                <GOLabel
                  label={t("common.begin")}
                  body={dayjs(data.startDate).format("YYYY-MM-DD a hh:mm:ss")}
                />
                <GOLabel
                  label={t("common.end")}
                  body={dayjs(data.endDate).format("YYYY-MM-DD a hh:mm:ss")}
                />
              </div>
              <div className="flex_box">
                <SmallTitle body={t("reservation.memo")} />
                <GOInput
                  label={t("common.memo")}
                  value={data.memo}
                  onChange={(e: any) =>
                    setData({ ...data, memo: e.target.value })
                  }
                  textarea
                />
              </div>
            </UFloatingBoxBody>
            <UFloatingBoxFooter>
              <GOButton
                buttontype="green"
                onClick={handleSubmit}
                body={t("common.edit")}
              />
              <GOButton
                buttontype="red"
                onClick={onDelete}
                body={t("common.del")}
              />
              <GOButton body={t("common.no")} onClick={props.onClickExit} />
            </UFloatingBoxFooter>
          </UFloatingContainer>
        </GOFloatingbox>
      </>
    );
  } else {
    return (
      <GOFloatingbox width={750}>
        <UFloatingContainer as="form">
          <UFloatingBoxHeader>
            <h1>{t("reservation.plateAvailableTime")}</h1>
            <p>{t("reservation.checkPlateReservationInfo")}</p>
          </UFloatingBoxHeader>
          <UFloatingBoxBody flex>
            <div className="flex_box">
              <SmallTitle body={t("reservation.personal")} />
              <GOLabel label={t("reservation.lessonName")} body={data.name} />
              <GOLabel
                label={t("common.begin")}
                body={dayjs(data.startDate).format("YYYY-MM-DD a hh:mm:ss")}
              />
              <GOLabel
                label={t("common.end")}
                body={dayjs(data.endDate).format("YYYY-MM-DD a hh:mm:ss")}
              />
              <br />
            </div>
            <div className="flex_box">
              <SmallTitle body={t("reservation.memo")} />
              <GOInput
                label={t("common.memo")}
                value={data.memo}
                onChange={(e: any) =>
                  setData({ ...data, memo: e.target.value })
                }
                textarea
              />
            </div>
          </UFloatingBoxBody>
          <UFloatingBoxFooter>
            <GOButton
              buttontype="green"
              onClick={handleSubmit}
              body={t("common.edit")}
            />
            <GOButton
              buttontype="red"
              onClick={onDelete}
              body={t("common.del")}
            />
            <GOButton body={t("common.no")} onClick={props.onClickExit} />
          </UFloatingBoxFooter>
        </UFloatingContainer>
      </GOFloatingbox>
    );
  }
};

export default Detail;
